import { Injectable, Injector, inject } from "@angular/core";
import { TranslateDefaultParser, TranslateService } from "@ngx-translate/core";
import { BrandingService, localizeStudentBranding } from "./branding.service";

type InterpolateExpr = Parameters<TranslateDefaultParser["interpolate"]>[0];
type InterpolationParameters = Record<string, unknown>;

/**
 * Supplies branding values (from the StudentPortalBranding table) to every translation, so
 * i18n strings can use {{programName}} / {{programSubtitle}} without each template passing them.
 * Explicit params passed to the translate pipe still win.
 */
@Injectable()
export class BrandingTranslateParser extends TranslateDefaultParser {
  private readonly injector = inject(Injector);
  private readonly branding = inject(BrandingService);

  override interpolate(
    expr: InterpolateExpr,
    params?: InterpolationParameters
  ): string | undefined {
    return super.interpolate(expr, { ...this.brandingParams(), ...params });
  }

  private brandingParams(): InterpolationParameters {
    // Resolved lazily: TranslateService itself depends on this parser.
    const lang = this.injector.get(TranslateService).getCurrentLang() || "en";
    const raw = this.branding.current;
    const localized = localizeStudentBranding(raw, lang);
    return {
      programName: localized.programTitle.trim() || raw.programTitleEn.trim(),
      programSubtitle: localized.programSubtitle.trim() || raw.programSubtitleEn.trim(),
      contactEmail: raw.contactEmail.trim(),
    };
  }
}
